export enum BidStatus {
  Cancelled = 'CANCELLED',
  Accepted = 'ACCEPTED',
  PENDING = 'PENDING',
  Rejected = 'REJECTED',
}